import React, {  MouseEvent  } from 'react';

interface BgisSearchDetailEntryProps {
  children: React.ReactNode;
  onMouseEnter?: (event: MouseEvent<HTMLLIElement>) => {};
  onMouseLeave?: (event: MouseEvent<HTMLLIElement>) => {};
  onMouseUp?: (event: MouseEvent<HTMLLIElement>) => {};
}

export const BgisSearchDetailEntry: React.FC<BgisSearchDetailEntryProps> = ({ children, onMouseEnter, onMouseLeave, onMouseUp }) => {
  
  return (
    <li className="bgis-hz bgis-hover bgis-border-bottom" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onMouseUp={onMouseUp}>
      <i className="bgis-icon bgis-icon-map-marker"> </i>
      <span className="bgis-txt">{children}</span>
    </li>
  );
};
